import type { SectionId } from '~/types/sectionId';

const THEME_MAP = {
    root: 'default',
    fachportal: 'fachportal',
    'pta-family': 'pta-family',
    academy: 'academy',
    urology: 'urology',
    nephrology: 'nephrology'
} as const satisfies Record<SectionId, string>;

export type ThemeName = (typeof THEME_MAP)[keyof typeof THEME_MAP];

export function usePlatformMeta() {
    const sectionConfig = useCurrentSectionConfig();
    const context = computed(() => sectionConfig.value?.sectionId ?? 'root');
    const theme = computed(() => THEME_MAP[context.value]);

    const isFachportal = computed(() => context.value === 'fachportal');
    const isPtaFamily = computed(() => context.value === 'pta-family');
    const isAcademy = computed(() => context.value === 'academy');
    const isUrology = computed(() => context.value === 'urology');
    const isNephrology = computed(() => context.value === 'nephrology');
    const isRoot = computed(() => context.value === 'root');

    return {
        /** The sectionId to target certain sections. Use for business logic. */
        context,
        /** The theme name to target a certain theme. Use for theming logic. */
        theme,
        isFachportal,
        isPtaFamily,
        isAcademy,
        isUrology,
        isNephrology,
        isRoot
    };
}
